import React from 'react';
import { Box, Typography } from '@material-ui/core';
import QRCode from 'react-qr-code';
import { QRCodeDownloadMenu } from '../../../../common/qr-code/QRCodeDownloadMenu';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';
import { useOrgInfo } from '../../../../global/auth/use-org-info/use-org-info';

interface FormQRCodePrintPageProps {
  formId: string;
  formTitle: string;
  orgLogo?: string | null;
  trigger: (onClick: (e: React.MouseEvent<HTMLElement>) => void) => React.ReactElement;
  onDone?: () => void;
}

export const FormQRCodePrintPage: React.FC<FormQRCodePrintPageProps> = ({
  formId,
  formTitle,
  orgLogo,
  trigger,
  onDone,
}) => {
  const { theme } = useCampfireTheme();
  const orgInfo = useOrgInfo();
  const formUrl = `${window.location.origin}/form/${formId}`;

  return (
    <QRCodeDownloadMenu
      value={formUrl}
      fileName={`${formTitle} QR code`}
      trigger={trigger}
      onDone={onDone}
      printContent={
        <Box
          style={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            padding: '48px',
            boxSizing: 'border-box',
          }}
        >
          {/* Org logo + name top right */}
          <Box
            style={{
              position: 'absolute',
              top: '40px',
              left: '48px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            {orgLogo && (
              <img src={orgLogo} alt={orgInfo?.name || 'Organisation logo'} style={{ height: '50px', width: 'auto' }} />
            )}
            {orgLogo && orgInfo?.name && <Box style={{ width: '1px', height: '32px', backgroundColor: '#ccc' }} />}
            {orgInfo?.name && (
              <Typography
                style={{
                  fontSize: '16px',
                  fontWeight: 600,
                  color: theme.color.grey.neutral400,
                }}
              >
                {orgInfo.name}
              </Typography>
            )}
          </Box>

          {/* Centered QR code */}
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '32px',
            }}
          >
            <QRCode value={formUrl} size={280} />
            <Typography
              style={{
                fontSize: '24px',
                fontWeight: 700,
                color: theme.color.grey.neutral400,
                textAlign: 'center',
              }}
            >
              {formTitle}
            </Typography>
            <Typography
              style={{
                fontSize: '14px',
                color: theme.color.grey.neutral300,
                textAlign: 'center',
              }}
            >
              Scan to open form
            </Typography>
          </Box>
        </Box>
      }
    />
  );
};
